import React from "react";
import { useSelector } from "react-redux";

const FilterItem = ({isActive, label, value, isLast, onClick, isDisabled}) => {
  const color = isDisabled ? 'text-gray-500' : isActive ? '' : 'text-primary'
  const weight = isActive ? 'font-bold' : ''
  const pointer = isDisabled || isActive ? '' : 'cursor-pointer'
  return (
    <>
      <div className="text-sm" onClick={onClick}>
        <span className={`${color} ${weight} ${pointer}`}>
          {label}
        </span> ({value})
      </div>
      {!isLast && <div className="mx-3">|</div>}
    </>
  )
}

const StatusFilter = ({ data, selected, setSelected = () => {} }) => {
  const { submissionStatusById, language } = useSelector(state => state.system)

  return <>
    {data && (
      <div className="flex flex-wrap items-center text-gray-444 text-sm lg:text-base">
        {data.map((d, index) => (
          <FilterItem
            key={index}
            label={d.id === 'all' ? (language.name === 'en' ? 'All' : 'Semua') : submissionStatusById[d.id]?.name[language.name]}
            value={d.value}
            isLast={index === data.length - 1}
            isActive={d.id === selected}
            isDisabled={d.value <= 0}
            onClick={d.value > 0 ? () => setSelected(d.id) : () => {}}
          />
        ))}
      </div>
    )}
  </>
};

export { StatusFilter };
